import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import CompanyFactory from "../../Entity/Factories/CompanyFactory";

export default function* companyList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "companies");

    // Iterate through each raw company data and convert them to objects.
    const companies = res.data.data.map(company => {
      return CompanyFactory.create(company);
    });

    yield put({
      type: Constants.GLOBAL_COMPANY_LIST_SUCCESS,
      payload: {
        companies: companies
      }
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchCompanyList() {
  yield takeEvery(Constants.GLOBAL_COMPANY_LIST, companyList);
}
